import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { useAuth, formatApiError } from "../context/AuthContext";
import { EASE } from "../components/motion";

export default function AdminLogin() {
  const { setUser, api } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${api}/auth/login`, form, { withCredentials: true });
      setUser(data);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border border-border rounded-sm px-4 py-3 text-sm text-navy placeholder:text-muted-foreground/60 focus:outline-none focus:border-accent transition-colors duration-300";

  return (
    <main className="min-h-screen flex items-center justify-center px-6 bg-secondary/30">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: EASE }}
        className="w-full max-w-md bg-background border border-border rounded-sm p-10 shadow-[0_20px_40px_-15px_rgba(10,17,40,0.08)]"
        data-testid="admin-login-card"
      >
        <img src="/assets/logo-crest.png" alt="Victoria Career College" className="h-28 w-auto" />
        <h1 className="mt-6 font-serif text-3xl text-navy">Administration</h1>
        <p className="mt-1 text-sm text-muted-foreground">Sign in to view student enquiries.</p>

        {error && (
          <p data-testid="login-error" className="mt-5 text-sm text-red-700 bg-red-50 border border-red-200 rounded-sm px-4 py-3">
            {error}
          </p>
        )}

        <form onSubmit={submit} className="mt-8 space-y-5">
          <label className="block">
            <span className="text-xs tracking-[0.18em] uppercase text-muted-foreground">Email</span>
            <input
              type="email"
              required
              data-testid="admin-email-input"
              className={`${inputCls} mt-2`}
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="admin@victoriacareercollege.ca"
            />
          </label>
          <label className="block">
            <span className="text-xs tracking-[0.18em] uppercase text-muted-foreground">Password</span>
            <input
              type="password"
              required
              data-testid="admin-password-input"
              className={`${inputCls} mt-2`}
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="••••••••"
            />
          </label>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            className="w-full bg-navy text-primary-foreground py-3.5 rounded-sm text-sm tracking-wide transition-colors duration-300 hover:bg-accent disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </motion.div>
    </main>
  );
}
